import { aboutDialogView, managementDialogView } from "./view.ts";

export type ManagementAction = "account" | "administration" | "appearance" | "external-calendars" | "integrations" | "data-management" | "archives" | "space-templates" | "invitations" | "onboarding" | "about" | "developer-tools";

export interface ManagementControllerCapabilities {
  document: Document;
  isAdmin: () => boolean;
  developerTools?: () => boolean;
  logo: () => string;
  icon: (name: string) => string;
  run: (action: Exclude<ManagementAction, "about">) => void;
}

export function createManagementController(capabilities: ManagementControllerCapabilities) {
  function show(dialog: HTMLDialogElement): void {
    const opener = capabilities.document.activeElement as HTMLElement | null;
    dialog.setAttribute("aria-label", dialog.querySelector("h2")?.textContent || "Settings & management");
    capabilities.document.body.append(dialog);
    dialog.addEventListener("close", () => { dialog.remove(); if (opener?.isConnected) opener.focus({ preventScroll: true }); });
    dialog.showModal();
  }

  function openAbout(): void {
    const dialog = capabilities.document.createElement("dialog");
    dialog.className = "name-dialog about-dialog";
    dialog.innerHTML = aboutDialogView(capabilities.logo(), capabilities.icon);
    dialog.querySelector(".about-dialog__close")!.addEventListener("click", () => dialog.close());
    show(dialog);
  }

  function open(): void {
    const dialog = capabilities.document.createElement("dialog");
    dialog.className = "name-dialog management-dialog";
    dialog.innerHTML = managementDialogView({ isAdmin: capabilities.isAdmin(), developerTools: capabilities.developerTools?.(), icon: capabilities.icon });
    dialog.querySelectorAll<HTMLElement>("[data-management-action]").forEach(button => button.addEventListener("click", () => {
      const action = button.dataset.managementAction as ManagementAction;
      dialog.close();
      if (action === "about") openAbout();
      else capabilities.run(action);
    }));
    show(dialog);
  }

  return { open, openAbout };
}
